import { IntegrationAddressVo, PaginationQuery } from "@/types";
import {
  IntegrationProductVo,
  IntegrationProductWithCartons,
} from "../product";

export type IntegrationOrderSearchParams = Partial<PaginationQuery> & {
  id?: number;
  ids?: string[];
  nos?: string[];
  customerName?: string;
  createdTimeRange?: string[];
  customerNumberLike?: string;
  type?: IntegrationOrderType;
  statusList?: IntegrationOrderStatus[];
};

export interface IntegrationOrderVo {
  id: string;
  type: IntegrationOrderType;
  status: IntegrationOrderStatus;
  customerId: number;
  customerName: string;
  synced: boolean;
  tried: number;
  cubeOrderId: string;
  cubeDeliveryNo: string;
  warehouseCode: string;
  addressId: number;
  shippingMethod: number;
  customerNumber: string;
  customerCode: string;
  docEntry: string;
  docNum: string;
  docType: string;
  extra: Record<string, unknown>;
  lark: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;

  address: IntegrationAddressVo;
}

export interface StockItem {
  productNo: string;
  quantity: number;
  singleBoxQuantity: number;
  lineNumber?: string;
}

export interface IntegrationOrderDetailVo extends IntegrationOrderVo {
  products: IntegrationProductVo[];
}

export interface IntegrationOrderDetailWithCartons extends IntegrationOrderDetailVo {
  products: IntegrationProductWithCartons[];
}

export enum IntegrationOrderType {
  Business = "B2B",
  Customer = "B2C",
}

export enum IntegrationOrderStatus {
  Created = "CREATED",
  Submitted = "SUBMITTED",
  Completed = "COMPLETED",
  Deleted = "DELETED",
  Acknowledged = "ACKNOWLEDGED",
}

export interface IntegrationDeleteOrderDo {
  orderId: number;
  hard?: boolean;
}

export interface IntegrationUpdateAssociatedCubeOrderDo {
  cubeOrderId: string;
  cubeUserCode: string;
}
